import { ImgProps } from "assets/images/types";

export default function ImgDiaDasMaesMmbbFooter2(props: ImgProps) {
	const { height = 295, width = 295 } = props;
	return (
		<img
			src="/assets/images/cases/dia-das-maes-mmbb/dia-das-maes-mmbb-footer-2.webp"
			alt="Arraste para dicas de massagem Shantala"
			loading="eager"
			width={width}
			height={height}
		/>
	);
}
